import { Stack, Text } from "prism-react";
import React from "react";

import type { Test } from "./types";

interface Props {
  tests: Test[];
}

export const Tests: React.FC<Props> = ({ tests }) => {
  if (tests.length === 0) {
    return null;
  }

  return (
    <Stack css={{ padding: "$2 $4" }} gap={1}>
      {tests.map((test, index) => (
        <Stack
          key={index}
          css={{ color: "$neutral-fg-subtle" }}
          gap={2}
          horizontal
        >
          {test.status === "pass" && (
            <Text color="informative-success-base">✓</Text>
          )}
          {test.status === "fail" && (
            <Text color="informative-error-base">✕</Text>
          )}
          {test.status === "idle" && (
            <Text color="informative-warning-base">○</Text>
          )}
          <Text color="neutral-fg-subtle">{test.name}</Text>
          {test.duration !== undefined && <Text>({test.duration} ms)</Text>}
        </Stack>
      ))}
    </Stack>
  );
};
